import React from 'react'
import { connect } from 'react-redux'
import { GoogleSignupButton } from '../../../Components/GoogleSignupButton';

const mapStateToProps = (state, params) => {
  return {
    text:         state.localization.dictionary.login.contGoogle
  }
}

const AuthGoogleSignupButtonConnected = connect(
  mapStateToProps,
)(GoogleSignupButton)


export {
  AuthGoogleSignupButtonConnected as SignupButton
}
